import ProgramEquipments from "./ProgramEquipments";
import VideoFeed from "../../common/VideoFeed";

function ProgramVideo({ selectedProgram, screenSize, label = () => { } }) {
    return (
        <div id="onb-v2-video-container">
            <VideoFeed
                thumbParams={selectedProgram?.thumbnail ? `/assets/images/V2/${selectedProgram?.thumbnail}` : null}
                video={{
                    video_id: selectedProgram?.video,
                    duration_watched: 0
                }}
                label={label}
                isIntro={true}
            />
            {
                screenSize == "xl" &&
                <ProgramEquipments selectedProgram={selectedProgram} />
            }

        </div>
    );
}

export default ProgramVideo;